// import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

export const useLocaleLanguage = () => {
  // const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const { isLoading } = useAppSelector(getSettings);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  // useEffect(() => {
    // dispatch(setLoading(true));
    // fetch("https://ipapi.co/json")
    //   .then((res) => res.json())
    //   .then((response) => {
    //     let lang, dir;
    //     if (response.country === "IL") {
    //       lang = "he";
    //       dir = "rtl";
    //     } else {
    // const lang = "he";
    // const dir = "rtl";
    // const title = "HE";
    // const lang = "en";
    // const dir = "ltr";
    // const title = "EN";
    // // }

    // i18n.changeLanguage(lang);
    // dispatch(setLanguage({ lang, dir, title }));
    // })
    // .catch((e) => {
    //   /*eslint-disable-next-line*/
    //   console.log(e);
    // })
    // .finally(() => dispatch(setLoading(false)));
  // }, []);

  return {
    isLoading,
    changeLanguage,
  };
};
